import { isEditableEventTarget } from '@littlebird/action-cards';
import { useEffect, useRef, type RefObject } from 'react';

// J, K or a click opens a card, and Enter closes it. Focus moves with the card: an opened frame
// takes focus, and a closed card gives focus back to its row. A field the user is typing in keeps focus
export const useFeedFocusHandoff = (
  open: boolean,
  focusesFrame: boolean,
  {
    frameRef,
    rowRef,
  }: {
    frameRef: RefObject<HTMLElement | null>;
    rowRef: RefObject<HTMLElement | null>;
  }
) => {
  const wasOpen = useRef(open);

  useEffect(() => {
    if (wasOpen.current === open) return;
    wasOpen.current = open;
    const active = document.activeElement;
    // A card that stays drawn open, as in an expanded feed, keeps focus that is already inside it
    if (isEditableEventTarget(active) || frameRef.current?.contains(active))
      return;
    if (open && focusesFrame) frameRef.current?.focus({ preventScroll: true });
    if (
      !open &&
      (!active || active === document.body || active === rowRef.current)
    )
      // The row's title opens and closes the card. Its checkbox comes first, and Enter on it would mark the card done
      (
        rowRef.current?.querySelector<HTMLElement>('button[aria-expanded]') ??
        rowRef.current?.querySelector<HTMLElement>('button')
      )?.focus({ preventScroll: true });
  }, [open, focusesFrame, frameRef, rowRef]);
};
